import React from "react";

const DashboardContentFooter = ({ username, handleLogout }) => {
  return (
    <footer className="footer">
      <p>
        &copy; 2025 Prosep Services Limited. All rights reserved. Developed by
        Reactive Developers. Contact: 0257335982
      </p>
    </footer>
  );
};

export default DashboardContentFooter;
